/**
 * Descarga universal de Blobs en DamyxIA.
 *
 * ESTRATEGIA UNICA (por decision oficial):
 *   window.open(URL.createObjectURL(blob), "_blank", "noopener,noreferrer")
 *
 * La imagen/ZIP/archivo se abre SIEMPRE en una pestana nueva y el usuario
 * usa el menu del navegador ("Guardar imagen como...", "Guardar como...",
 * etc.) para elegir la carpeta de destino. Este comportamiento funciona de
 * forma IDENTICA en:
 *   - Chrome / Edge (desktop + Android)
 *   - Safari (macOS + iOS)
 *   - Firefox (desktop + Android)
 *   - Cualquier iframe cross-origin (preview Emergent, produccion embebida)
 *
 * NO se usa `showSaveFilePicker` / File System Access API bajo ningun
 * concepto: genera regresiones y es inestable en iframes, Safari y Firefox.
 *
 * Fallback unico: si el navegador bloquea el popup (window.open devuelve
 * null), se cae a un <a download> para que la imagen NO quede perdida. El
 * usuario recibe en ese caso la imagen en la carpeta Descargas por defecto.
 *
 * Retorna:
 *   'newtab'    → imagen abierta en pestana nueva (camino principal)
 *   'fallback'  → popup bloqueado, se disparo <a download>
 */

function _forceDownload(blob, suggestedName) {
  try {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = suggestedName || 'download';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return 'fallback';
  } catch (_err) {
    return 'fallback';
  }
}

/**
 * Abre un Blob en una pestana nueva. Camino oficial y unico de descarga
 * para imagenes en DamyxIA. El usuario elige la carpeta desde el menu del
 * navegador ("Guardar imagen como...").
 *
 * @param {Blob} blob
 * @param {string} suggestedName  Nombre sugerido (se usa en fallback <a download>).
 * @returns {'newtab' | 'fallback'}
 */
export function openBlobInNewTab(blob, suggestedName = 'damyxia.png') {
  try {
    const url = URL.createObjectURL(blob);
    const win = window.open(url, '_blank', 'noopener,noreferrer');
    // Liberar el blob URL despues de que la pestana cargue.
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    if (win) return 'newtab';
    // Popup bloqueado → ultimo recurso: <a download>.
    URL.revokeObjectURL(url);
    return _forceDownload(blob, suggestedName);
  } catch (_err) {
    return _forceDownload(blob, suggestedName);
  }
}

/**
 * Alias de compatibilidad para llamadores que todavia importan
 * `saveBlobWithPicker`. Mantiene la misma firma pero implementa la
 * estrategia oficial (nueva pestana). El parametro `opts` se ignora.
 *
 * @param {Blob} blob
 * @param {string} suggestedName
 * @param {string} _mimeType    No se usa (preservado por compat).
 * @param {object} _opts        No se usa (preservado por compat).
 * @returns {Promise<'newtab' | 'fallback'>}
 */
export async function saveBlobWithPicker(blob, suggestedName, _mimeType = 'image/png', _opts = {}) {
  return openBlobInNewTab(blob, suggestedName);
}
